import { type Context, useContext } from 'react';

import twigPropsContext from '../../context/TwigPropsContext/TwigPropsContext';

const useTwigPropsContext = <T extends object>() => useContext<T>(twigPropsContext as Context<T>);

export default useTwigPropsContext;
